export default "__VITE_ASSET__CRJOvq66__"